import { FnAxiosInstance } from 'src/shared/services/axios/axios';

export class IntercomToken
{
    appId: string | undefined;
    jwt: string | undefined;
    companyHasIntercomMessenger: boolean | undefined;
    companyHasIntercom: boolean | undefined;
}

export class KeyManager {
    public static async getKeyFor(value: string): Promise<string> {
        try {
            const keyMan = new KeyManager();
            const compressedBytes = keyMan.base64ToBytes(value);

            const stream = new Blob([compressedBytes.buffer as ArrayBuffer]).stream();
            const decompressedStream = stream.pipeThrough(new DecompressionStream("gzip"));
            const chunks = [];
            for await (const chunk of decompressedStream) {
                chunks.push(chunk);
            }

            const stringBytes = await keyMan.concatUint8Arrays(chunks);
            const decompressedString = new TextDecoder().decode(stringBytes);
            return keyMan.deobfuscate(decompressedString);
        } catch (error) {
            console.error("Error during key decomposition:", error);
            return value;   // already returns as Promise due to async function
        }
    }

    public static async getTokenFor(beneId: number): Promise<IntercomToken> {
      const query = `/license/intercom?beneId=${beneId}`;
      const response = await FnAxiosInstance.get(query);
      return response.data;
    }

    private base64ToBytes(b64: string): Uint8Array {
        const binary = atob(b64);
        const len = binary.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++){
            bytes[i] = binary.charCodeAt(i);
        }
        return bytes;
    }

    private async concatUint8Arrays(arrays: Uint8Array[]): Promise<Uint8Array> {
        const blob = new Blob(arrays as Array<BlobPart>);
        const buffer = await blob.arrayBuffer();
        return new Uint8Array(buffer);
    }

    private deobfuscate(message: string): string {
        return message.split('')
            .map((_, index) => String.fromCharCode(message.charCodeAt(index) - 2))
            .join('');
    }
}